// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

.ImageUploader_container__mgWAi {
    border: solid 1px #c4c4c4;
    margin-top: 5px;
    border-radius: 0.5rem;
}

.ImageUploader_imgList__xbjOn {
    /* width: 580; */
    height: 250px;
    margin-left: 15px;
    overflow-x: clip;
    overflow-y: auto;
}

.ImageUploader_itemContainer__xRf5j {
    width: 10;
    height: 10;
}

.ImageUploader_image__Rp0FH {
    border-style: solid;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-color: black;
    border-width: 1px;
}

.ImageUploader_imageBar__259O7 {
    background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 0%);
}

.ImageUploader_closeIcon__f87Ql {
    color: white;
    background: black;
    height: 2px;
    width: 2px;
    padding: 10px;
}

.ImageUploader_buttonContainer__VkTH4 {
    display: flex;
    justify-content: right;
    margin: 0 5px 5px 0;
}`, "",{"version":3,"sources":["webpack://./src/Components/Shared/ImageUploader.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,yBAAyB;IACzB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gGAAgG;AACpG;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 29/3/2023\r\n */\r\n\r\n.container {\r\n    border: solid 1px #c4c4c4;\r\n    margin-top: 5px;\r\n    border-radius: 0.5rem;\r\n}\r\n\r\n.imgList {\r\n    /* width: 580; */\r\n    height: 250px;\r\n    margin-left: 15px;\r\n    overflow-x: clip;\r\n    overflow-y: auto;\r\n}\r\n\r\n.itemContainer {\r\n    width: 10;\r\n    height: 10;\r\n}\r\n\r\n.image {\r\n    border-style: solid;\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    object-fit: contain;\r\n    border-color: black;\r\n    border-width: 1px;\r\n}\r\n\r\n.imageBar {\r\n    background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 0%);\r\n}\r\n\r\n.closeIcon {\r\n    color: white;\r\n    background: black;\r\n    height: 2px;\r\n    width: 2px;\r\n    padding: 10px;\r\n}\r\n\r\n.buttonContainer {\r\n    display: flex;\r\n    justify-content: right;\r\n    margin: 0 5px 5px 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ImageUploader_container__mgWAi`,
	"imgList": `ImageUploader_imgList__xbjOn`,
	"itemContainer": `ImageUploader_itemContainer__xRf5j`,
	"image": `ImageUploader_image__Rp0FH`,
	"imageBar": `ImageUploader_imageBar__259O7`,
	"closeIcon": `ImageUploader_closeIcon__f87Ql`,
	"buttonContainer": `ImageUploader_buttonContainer__VkTH4`
};
export default ___CSS_LOADER_EXPORT___;
